var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 8,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4h120v120H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 123l26-38 25 35 32-60 29 63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 39.5,
    r: 15.5
  }))));
}
export default SvgImage;